export default {
  baseUrl: 'https://shop-server.veniqa.com/',
  registerUrl: '/security/signup',
  loginUrl: '/security/login',
  logoutUrl: '/security/logout',
  getCsrfTokenAndStatus: '/getCsrfTokenAndStatus',
  isSessionActive: '/security/isLoggedIn',
  forgotPassword: '/security/forgotPassword?email=',
  validateResetToken: '/security/validatePasswordResetToken/',
  resetPassword: '/security/resetPassword',
  resendEmailConfirmation: '/security/resendEmailAddressConfirmationLink?email=',
  recaptcha: 'https://www.google.com/recaptcha/api/siteverify',

  searchProduct: '/catalog/search',
  getProductDefinitionUrl: '/catalog/getProductDetails?productId=',
  confirmEmail: '/security/confirmEmailAddress',
  resendEmail: '/security/resendEmailAddressConfirmationLink?email=',

  // Shopping cart
  addToCart: '/shopping/addToCart',
  getCart: '/shopping/getCart',
  deleteCart: '/shopping/deleteFromCart',
  updateCart: '/shopping/updateCart',
  changeItemSelectedStatus: '/shopping/changeItemSelectedStatus',
  selectAllItemsForCheckout: '/shopping/selectAllItemsForCheckout',

  // Account URLS
  getAccountData: '/user/accountData',
  personalInfo: '/user/personalInfo',

  /* Account security */
  changePassword: "/user/changePassword",
  changePhoneNum: "/user/changePhoneNum",

  /* Account addresses */
  address: '/user/address',
  setDefaultAddress: '/user/address/setDefaultAddress',

  createCheckoutSession: 'orders/createCheckoutSession',
  validateCheckout: 'orders/validateCheckout',
  completeCheckout: 'orders/completeCheckout',

  featuredUrl: '/ui/featured?name=',

  // Order list
  orderList: '/user/orderList',
  orderDetail: '/user/orderDetails?orderId=',
  // Payment URLS
  stripePay: '/orders/completeCheckoutUsingCard',
  khaltiPay: '/orders/completeCheckoutUsingKhalti',
  
  // Stripe Payment Intents
  stripeInstantPay: '/orders/stripePaymentInstant',
  stripeInstantPayment: '/orders/completeCheckoutUsingStripePaymentInstant',

  // Categories List
  categoriesUrl: '/ui/productCategoryList',

  // Site data/info
  initialContent: '/siteData/initialContent',
  privacyPolicy: '/siteData/privacyPolicy',
  termsAndConditions: '/siteData/termsAndConditions',
  getContactData: '/siteData/contactData',



  // ----------- INSTANCE CONFIGURATION API URLS --------------------------
  getInstanceFeatFlags: '/feature-flags/getAllFeatureFlags'
};
